import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Button } from "@mui/material";
import API from "../service/api";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "400px",
  width: "100%",
  bgcolor: "background.paper",
  border: "5px solid rgb(255, 0, 208)",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

interface DuplicateModalProps {
  openModal: boolean;
  toggleModal: () => void;
  description: string;
  pupilId: number;
  reRegisterCase: string;
  classId:number;
  preId:number;
}

export default function DuplicateModal({
  openModal,
  toggleModal,
  description,
  pupilId,
  reRegisterCase,
  classId,
  preId
}: DuplicateModalProps) {
  const exitModal = async () => {

      console.log("pupilId", pupilId);

      try {
        await API.post(
          process.env.REACT_APP_API_ENDPOINT +
            "Application/confirm-rergister?pupilId=" + pupilId +"&reRegisterCase=" +reRegisterCase+"&classId=" + classId+"&preId=" + preId
        ); 
          window.location.reload();
      } catch (e) {}

  };
  return (
    <div>
      <Modal
        open={openModal}
        onClose={toggleModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-description" sx={{ textAlign: "center" }}>
            {description}
          </Typography>

          <Box
            display={"flex"}
            justifyContent="center"
            flexDirection={"column"}
            gap={3}
          >
            <Button
              type="submit"
              variant="contained"
              sx={{ minWidth: 200 }}
              style={{
                background: "#199D18",
                borderRadius: "10px",
                fontSize: "16px",
                marginTop: "50px",
                marginBottom: "50px",
                textTransform: "none",
              }}
              onClick={exitModal}
            >
              Confirm & Exit
            </Button>
          </Box>

          <Typography id="modal-modal-description" sx={{ textAlign: "center" }}>
            If any information is incorrect or you have any other queries, please contact us via phone or email.
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
